import { Lang } from '../../i18n';

/** 61.234 -> "1:01.23"; null -> "-:--.--". */
export function formatTime(s: number | null | undefined): string {
  if (s === null || s === undefined || !Number.isFinite(s) || s < 0) return '-:--.--';
  const cs = Math.round(s * 100);
  const m = Math.floor(cs / 6000), sec = Math.floor((cs % 6000) / 100), c = cs % 100;
  return `${m}:${String(sec).padStart(2, '0')}.${String(c).padStart(2, '0')}`;
}

/** Signed split vs a reference: "+1.20" / "-0.35". */
export function formatDelta(d: number): string {
  const v = Math.round(Math.abs(d) * 100) / 100;
  return `${d < 0 ? '-' : '+'}${v.toFixed(2)}`;
}

/** m/s -> whole km/h as text (never "-0"). */
export const formatSpeed = (ms: number): string => String(Math.max(0, Math.round(Math.abs(ms) * 3.6)));

/** Number with the language's decimal separator. */
export function formatNumber(v: number, lang: Lang, digits = 1): string {
  const tag = lang === 'ua' ? 'uk-UA' : lang === 'pl' ? 'pl-PL' : lang === 'ru' ? 'ru-RU' : 'en-GB';
  return new Intl.NumberFormat(tag, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v);
}

/** [true, true, false] for 2 of 3. */
export const starRow = (stars: number, max = 3): boolean[] => Array.from({ length: max }, (_, i) => i < stars);
